import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { ListOl, CameraVideoFill, TrophyFill } from "react-bootstrap-icons";
import { Helmet } from "react-helmet";

const Home = (props) => {
  const title = "Sightstones";
  return (
    <>
      <Helmet
        title={title}
        meta={[
          { name: "twitter:card", content: "summary" },
          {
            property: "og:url",
            content:
              "https://sightstones.netlify.app" + props.location.pathname,
          },
          { property: "og:title", content: title },
          {
            property: "og:image",
            content: "https://sightstones.netlify.app/img/ogp.png",
          },
        ]}
      >
        <script
          async
          src="//static.zotabox.com/c/9/c950e8fa34109405fa5392a5b7259d47/widgets.js"
        ></script>
      </Helmet>
      <div className="d-flex align-items-center flex-column justify-content-center h-100-flex bg-light">
        <header className="text-center">
          <h1 className="home-title">{title}</h1>
        </header>
        <section className="text-center w-100">
          <Container>
            <Row>
              <Col sm={6} lg={3}>
                <div className="py-5 mb-5 bg-white shadow-sm rounded">
                  <div className="mx-auto home-icon-box rounded-circle common-bg-lightblue">
                    <ListOl size={72} className="p-4" />
                  </div>
                  <h2 className="h5 my-4">LJL Player&apos;s Toplist</h2>
                  <Link to="/toplist/jp/" className="btn btn-primary">
                    OPEN
                  </Link>
                </div>
              </Col>
              <Col sm={6} lg={3}>
                <div className="py-5 mb-5 bg-white shadow-sm rounded">
                  <div className="mx-auto home-icon-box rounded-circle common-bg-lightblue">
                    <ListOl size={72} className="p-4" />
                  </div>
                  <h2 className="h5 my-4">LCK Player&apos;s Toplist</h2>
                  <Link to="/toplist/kr/" className="btn btn-primary">
                    OPEN
                  </Link>
                </div>
              </Col>
              <Col sm={6} lg={3}>
                <div className="py-5 mb-5 bg-white shadow-sm rounded">
                  <div className="mx-auto home-icon-box rounded-circle common-bg-lightblue">
                    <CameraVideoFill size={72} className="p-4" />
                  </div>
                  <h2 className="h5 my-4">LoL Stream Checker</h2>
                  <Link to="/stream/jp/" className="btn btn-primary">
                    OPEN
                  </Link>
                </div>
              </Col>
              <Col sm={6} lg={3}>
                <div className="py-5 mb-5 bg-white shadow-sm rounded">
                  <div className="mx-auto home-icon-box rounded-circle common-bg-lightblue">
                    <TrophyFill size={72} className="p-4" />
                  </div>
                  <h2 className="h5 my-4">LoL Esports Matches</h2>
                  <Link to="/matches/" className="btn btn-primary">
                    OPEN
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <footer className="text-center mt-5">
          <Container>
            <Row>
              <Col>
                <p className="text-muted">
                  {title} isn&apos;t endorsed by Riot Games and doesn&apos;t
                  reflect the views or opinions of Riot Games or anyone
                  officially involved in producing or managing League of
                  Legends. League of Legends and Riot Games are trademarks or
                  registered trademarks of Riot Games, Inc. League of Legends ©
                  Riot Games, Inc.
                </p>
                <p>&copy; 2015 {title}</p>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </>
  );
};

export default Home;
